import { lazy, Suspense, useEffect, useState } from 'react';

import { Route, Routes, Navigate } from 'react-router-dom';
import { MasterLayout } from '../../_vtsl/layout/MasterLayout';
import TopBarProgress from 'react-topbar-progress-indicator';
import { getCSSVariableValue } from '../../_vtsl/assets/ts/_utils';
import { DisableSidebar } from '../../_vtsl/layout/core';
import { useAuth } from '../modules/auth';
import { Buffer } from 'buffer';
import { isExtensionImpersonationSession } from './extensionImpersonation';

const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'));
const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'));
const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'));
const CallControl = lazy(() => import('../modules/apps/Call-Control/CallControl'));
const VoiceMail = lazy(() => import('../modules/apps/Voice-Mail/VoiceMail'));
const CDRS_USER = lazy(() => import('../modules/apps/Cdrs/Cdrs'));
const CallGroups = lazy(() => import('../modules/apps/Call-Groups/CallGroups'));
const Schedules = lazy(() => import('../modules/apps/Schedules/Schedules'));
const BlockNumbers = lazy(() => import('../modules/apps/Blocked-Numbers/BlockNumber'));
const Directory = lazy(() => import('../modules/apps/Directory/Directory'));
const Reporting = lazy(() => import('../modules/apps/Reporting/Reporting'));
const BusinessGroups = lazy(() => import('../modules/apps/businessGroups/BusinessGroups'));
const Scheduling = lazy(() => import('../modules/apps/Reporting/Scheduling'));
const CreateScheduling = lazy(() => import('../modules/apps/Reporting/CreateScheduling'));
const CreateBusinessGroups = lazy(() => import('../modules/apps/businessGroups/CreateBusinessGroups'));
const AddGroups = lazy(() => import('../modules/apps/Add-Groups/AddGroups'));
const IncomingCallRoute = lazy(() => import('../modules/apps/Incoming-Call-Route/IncomingCallRoute'));
const IncomingCallDetails = lazy(() => import('../modules/apps/Incoming-Call-Route/Incoming-call-details/IncomingCallDetails'));
const CallGroupsDetails = lazy(() => import('../modules/apps/Call-Groups/Call-Groups-details/CallGroupsDetails'));
const SelectiveCall = lazy(() => import('../modules/apps/Call-Control/Selective-call/selectiveCall'));
const MyNumber = lazy(() => import('../modules/apps/My-Numbers/MyNumbers'));
const UserInformation = lazy(() => import('../modules/apps/User-Information/UserInformation'));
const UserInformationDetails = lazy(() => import('../modules/apps/User-Information-details/UserInformationDetails'));
const UserInformationDetailsLocation = lazy(() => import('../modules/apps/User-Information-details-Location/UserInformationDetails'));
const AddCallingGroups = lazy(() => import('../modules/apps/Add-Call-Groups/AddCallingGroups'));
const AddMonitorGroups = lazy(() => import('../modules/apps/Monitor-Groups/AddMonitorGroups'));
const MonitorGroupsDetails = lazy(() => import('../modules/apps/Monitor-Groups/MonitorGroupsDetails'));
const CallPermissionProfile = lazy(() => import('../modules/apps/Call-Permission-Profile/CallPermissionProfile'));
const CallPermissionProfileDetails = lazy(() => import('../modules/apps/Call-Permission-Profile/CallPermissionProfileDetails'));
const AddCallGroupsDetails = lazy(() => import('../modules/apps/Add-Call-Groups/Add-Call-Groups-details/AddCallGroupsDetails'));
const AddQueueGroupsDetails = lazy(() => import('../modules/apps/Add-Queue-Groups/Add-Queue-Groups-details/AddQueueGroupsDetails'));
const AddQueueGroups = lazy(() => import('../modules/apps/Add-Queue-Groups/AddQueueGroups'));
const PresenceState = lazy(() => import('../modules/apps/Presence-State/PresenceState'));
const AutoAttendants = lazy(() => import('../modules/apps/Auto-Attendants/AutoAttendants'));
const AutoAttendantsDetails = lazy(() => import('../modules/apps/Auto-Attendants/Auto-Attendants-details/AutoAttendantsDetails'));
const BusinessHours = lazy(() => import('../modules/apps/Business-Hours/BusinessHours'));
const BusinessHoursdetails = lazy(() => import('../modules/apps/Business-Hours/BusinessHoursdetails'));
const PhoneKeyProfiles = lazy(() => import('../modules/apps/Phone-Key-Profiles /PhoneKeyProfiles'));
const HolidayHours = lazy(() => import('../modules/apps/Holiday-Hours/HolidayHours'));
const HolidayHoursDetails = lazy(() => import('../modules/apps/Holiday-Hours/HolidayHoursDetails'));
const CdrsTenent = lazy(() => import('../modules/apps/CdrsTenent/CdrsTenent'));
const Salesforce = lazy(() => import('../modules/apps/Salesforce/Salesforce'));
const SalesforceDetails = lazy(() => import('../modules/apps/Salesforce/SalesforceDetails'));
const Dashboards = lazy(() => import('../modules/apps/Dashboards/Dashboards'));
const Tenant = lazy(() => import('../modules/apps/Tenant/Tenant'));
const Licensing = lazy(() => import('../modules/apps/Licensing/Licensing'));
const LicensingUsers = lazy(() => import('../modules/apps/Licensing/LicensingUsers'));

const PrivateRoutes = () => {
  const { currentUser, logout, setCurrentUser } = useAuth();
  const [pin, setPin] = useState();
  const [userType, setUserType] = useState();

  const [reseller, setReseller] = useState();
  const [showLogout, setShowLogout] = useState(false);

  useEffect(() => {
    const b_token = localStorage.getItem('B_Token')
    const decodedToken = Buffer.from(b_token, "base64").toString()
    const pin = decodedToken.split(":")[1]
    setPin(pin)
    const userType = localStorage.getItem('user_type')
    setUserType(userType)
    const reseller = localStorage.getItem('is_reseller')
    setReseller(reseller)
    const showLogout = localStorage.getItem('ShowLogout')
    setShowLogout(showLogout)


  }, []);




  return (<Routes>
    <Route element={<MasterLayout />}>
      {/* Redirect to Dashboard after success login/registartion */}
      <Route path='auth' element={<Navigate to='/profile' />} />

      {/* Pages */}
      {/* <Route path='dashboard' element={<DashboardWrapper />}/> */}

      {/* Lazy Modules */}
      <Route path='profile' element={<SuspensedView>
        <ProfilePage />
      </SuspensedView>} />

      <Route path='crafted/pages/wizards' element={<SuspensedView>
        <WizardsPage />
      </SuspensedView>} />
      {/* <Route path='resellerlogin' element={<SuspensedView>
        <ResellerLogin />
      </SuspensedView>} /> */}
      <Route path='user-management' element={<SuspensedView>
        <UsersPage />
      </SuspensedView>} />
      <Route path='call-control' element={<SuspensedView>
        <CallControl />
      </SuspensedView>} />
      <Route path='blocknumbers' element={<SuspensedView>
        <BlockNumbers />
      </SuspensedView>} />
      <Route path='directory' element={<SuspensedView>
        <Directory />
      </SuspensedView>} />
      <Route path='reporting' element={<SuspensedView>
        <Reporting />
      </SuspensedView>} />
      <Route path='scheduling' element={<SuspensedView>
        <Scheduling />
      </SuspensedView>} />
      <Route path='create-scheduling' element={<SuspensedView>
        <CreateScheduling />
      </SuspensedView>} />
      <Route path='create-business-groups' element={<SuspensedView>
        <CreateBusinessGroups />
      </SuspensedView>} />


      <Route path='mynumber' element={<SuspensedView>
        <MyNumber />
      </SuspensedView>} />
      <Route path='selectivecall' element={<SuspensedView>
        <SelectiveCall />
      </SuspensedView>} />

      <Route path='cdrs-user' element={<SuspensedView>
        <CDRS_USER />
      </SuspensedView>} />
      <Route path='cdrsTenant'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User' || isExtensionImpersonationSession()) {
              return (
                <SuspensedView>
                  <CdrsTenent />
                </SuspensedView>
              );
            }
            return <Navigate to='/error/404' />;
          })()
        }

      />
      <Route path='licensing'

        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User') {
              return (
                <SuspensedView>
                  <Licensing />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route path='licensing/users'

        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User') {
              return (
                <SuspensedView>
                  <LicensingUsers />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      {/* <Route
        path='tenantManagement'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            const showLogout = localStorage.getItem('ShowLogout');

            if (userType !== 'User - Manager' && userType !== 'User' && !showLogout) {
              return (
                <SuspensedView>
                  <Tenant />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      /> */}
      <Route
        path='tenantManagement'
        element={

          <SuspensedView>
            <Tenant />
          </SuspensedView>

        }
      />

      <Route path='call-groups'
        element={
          <SuspensedView>
            <CallGroups />
          </SuspensedView>
          // (() => {
          //   const userType = localStorage.getItem('user_type');
          //   if (userType !== 'User - Manager' && userType !== 'User') {
          //     return (

          //     );
          //   } else {
          //     return <Navigate to='/error/404' />; // Redirect to unauthorized page
          //   }
          // })()
        }
      />

      <Route path='voice-mail'
        element={
          <SuspensedView>
            <VoiceMail />
          </SuspensedView>
        }
      />
      <Route path='Schedules'
        element={
          <SuspensedView>
            <Schedules />
          </SuspensedView>
        }

      />
      <Route path='business-groups'
        element={
          <SuspensedView>
            <BusinessGroups />
          </SuspensedView>
        }

      />


      <Route path='call-groups-details/:groupId'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <CallGroupsDetails />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route path='userManagemnet'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User') {
              return (
                <SuspensedView>
                  <UserInformation />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />

      <Route path='incomingcallroute/:didId'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User') {
              return (
                <SuspensedView>
                  <IncomingCallDetails />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route path='userManagemnet/details'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User') {
              return (
                <SuspensedView>
                  <UserInformationDetails />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route path='/userManagemnetLocation/details'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User') {
              return (
                <SuspensedView>
                  <UserInformationDetailsLocation />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />


      <Route path='userprofiles'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <AddGroups />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route path='incomingcallroute'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <IncomingCallRoute />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />

      <Route path='calling-groups'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <AddCallingGroups />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route path='monitor-groups'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <AddMonitorGroups />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route path='monitor-groups-details/:groupId/:groupName'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  < MonitorGroupsDetails />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />

      {/* ///// */}

      <Route path='call-permission-profile'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <CallPermissionProfile />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route path='call-permission-profile-details'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  < CallPermissionProfileDetails />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />


      {/* //// */}
      <Route path='add-calling-groups' element={<SuspensedView>
        <AddCallGroupsDetails />
      </SuspensedView>} />
      <Route
        path='queue-groups'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <AddQueueGroups />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }

      />
      <Route
        path='add-queue-groups'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <AddQueueGroupsDetails />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />

      <Route
        path='presence-state/:didId'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <PresenceState />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route
        path='auto-attendants'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <AutoAttendants />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route
        path='auto-attendants-details'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <AutoAttendantsDetails />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route
        path='business-hours'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <BusinessHours />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route
        path='business-hours-details'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <BusinessHoursdetails />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route
        path='phone-key-profiles'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <PhoneKeyProfiles />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route
        path='scheduledivets'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <HolidayHours />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route
        path='scheduledivets-details'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <HolidayHoursDetails />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route
        path='salesforce'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <Salesforce />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />
      <Route
        path='salesforce-details'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <SalesforceDetails />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }
      />



      {/* <Route path={`${process.env.PUBLIC_URL}/cdrs`} render={(props) => <CDRS {...props} />} />
      <Route path={`${process.env.PUBLIC_URL}/cdrs-table`} render={(props) => <CDRSTABLE {...props} />} /> */}


      {/* <Route path='callMonitoring'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User') {
              return (
                <SuspensedView>
                  <CallMonitoring />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }

      /> */}
      {/* <Route path='callMonitoring'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User') {
              return (
                <SuspensedView>
                  <CallMonitoring2 />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />; // Redirect to unauthorized page
            }
          })()
        }

      /> */}
      {/* ////////////DASHBAORDS///// */}



      <Route path='dashboards'
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <Dashboards />
                </SuspensedView>
              );
            }
            if (isExtensionImpersonationSession()) {
              return (
                <SuspensedView>
                  <Dashboards />
                </SuspensedView>
              );
            }
            return <Navigate to='/error/404' />;
          })()
        }
      />
      {/* <Route
        path={`cdrs`}
        element={
          (() => {
            const userType = localStorage.getItem('user_type');
            if (userType !== 'User - Manager' && userType !== 'User') {
              return (
                <SuspensedView>
                  <CDRS />
                </SuspensedView>
              );
            } else {
              return <Navigate to='/error/404' />;
            }
          })()
        }
      /> */}


      {/* Page Not Found */}
      <Route path='dashboards' element={<Navigate to='/dashboards' />} />
      <Route path='cdrs' element={<Navigate to='/cdrs' />} />

      <Route path='*' element={<Navigate to='/error/404' />} />
    </Route>
  </Routes>);
};
const SuspensedView = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary');
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return (<Suspense fallback={<TopBarProgress />}>
    <DisableSidebar>{children}</DisableSidebar>
  </Suspense>);
};
export { PrivateRoutes };
